import React from 'react';
import { useTranslation } from 'react-i18next'
import { Add, Copy, Down, Edit, Remove, Up, View } from '../../../components/Icons/Icons';
import { Tooltip } from "../../../components/Utils/Tooltips";

const DeletePatient = ({ deletePatient, medicalRecordNumber }) => {
    const { t } = useTranslation();

    return (
        <Tooltip tooltip={t("protocols.groups.actionDeletePatient")}>
            <button className="btn-remove btn-table-actions" onClick={() => deletePatient(medicalRecordNumber)}>
                <Remove />
            </button>
        </Tooltip>

    );
};

export default DeletePatient;